import { AbstractDocument, Timestampable, Untrackable } from '../../../abstract/Document';
import type { ISupplierAppsInstagram } from './instagram.types';

@Timestampable
@Untrackable
export class AppsInstagram extends AbstractDocument<ISupplierAppsInstagram> {
  readonly collections = {};
}
